// default elevations in the openings tables and printouts: an opening with no drw elevation of a
// kind renders a default (a rendering with no elevation link). See
// elevationTool/default-elevations-plan.md.

// the elevation name a default shows (topening.DrwDefaultElevationName).
export const drwDefaultElevationName = "DEFAULT";

export type DrwKind = "screen" | "door" | "hardware";

type DrwElevationRow = {
    drwScreenElevation?: number | null;
    drwDoorElevation?: number | null;
    drwHardwareElevation?: number | null;
    drwScreenElevationName?: string | null;
    drwDoorElevationName?: string | null;
    drwHardwareElevationName?: string | null;
    drwScreenRendering?: number | null;
    drwDoorRendering?: number | null;
    drwHardwareRendering?: number | null;
};

function fieldsFor(row: DrwElevationRow, kind: DrwKind) {
    switch(kind) {
        case "screen":
            return {link: row.drwScreenElevation, name: row.drwScreenElevationName, rendering: row.drwScreenRendering};
        case "door":
            return {link: row.drwDoorElevation, name: row.drwDoorElevationName, rendering: row.drwDoorRendering};
        case "hardware":
            return {link: row.drwHardwareElevation, name: row.drwHardwareElevationName, rendering: row.drwHardwareRendering};
    }
}

export function isDrwDefault(row: DrwElevationRow, kind: DrwKind): boolean {
    const f = fieldsFor(row, kind);
    return !f.link && !!f.rendering;
}

// the drw elevation name to print for a kind: the linked elevation's name, DEFAULT for a default,
// else "".
export function drwElevationName(row: DrwElevationRow, kind: DrwKind): string {
    if(isDrwDefault(row, kind)) return drwDefaultElevationName;
    const f = fieldsFor(row, kind);
    return f.link ? (f.name || "") : "";
}
